import { GroupManagement } from "@/features/admin/group-management";

export default function AdminGroupsPage() {
  return <GroupManagement />;
}
